// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { ClientProfileBasicFragment } from '../../../clientProfiles/graphql/ClientProfile.generated';
import { EntityTaskFragment } from '../../../tasks/graphql/TaskQueries.generated';
import { AssetValuationV2Fragment } from '../../../assetValuation/graphql/entityValuationQueries.generated';
import { gql } from '@apollo/client';
import { ClientProfileBasicFragmentDoc } from '../../../clientProfiles/graphql/ClientProfile.generated';
import { EntityTaskFragmentDoc } from '../../../tasks/graphql/TaskQueries.generated';
import { AssetValuationV2FragmentDoc } from '../../../assetValuation/graphql/entityValuationQueries.generated';
export type GratTrustFragment = { __typename?: 'GRATTrust', id: string, distributionDate?: Time | null, displayName: string, annuityAnnualIncreasePercent?: Percent | null, gstStatus?: Types.EntityGstStatus | null, effectiveDate?: Time | null, downsideThresholdPercent?: Percent | null, assetSummaryDisplay?: string | null, completionDate?: Time | null, grantorRetainedInterest: CurrencyUSD, currentValue: CurrencyUSD, description?: string | null, gratSummaryDisplay?: string | null, implementationNotesToAttorney?: string | null, impliedEstateTaxSavings: CurrencyUSD, inEstateStatus: Types.EntityInEstateStatus, legalName?: string | null, officialInterestRatePercent?: Percent | null, projectedMarketValue?: CurrencyUSD | null, projectedRateOfReturn?: Percent | null, projectedSharePrice?: CurrencyUSD | null, rollingPeriodYears?: number | null, targetTaxableGift?: CurrencyUSD | null, taxStatus?: Types.TrustTaxStatus | null, taxableGift?: CurrencyUSD | null, termDurationYears?: number | null, termEndDate?: Time | null, trustJurisdictionStateCode?: string | null, upsideAsTargetSurplus: boolean, upsideThresholdPercent?: Percent | null, upsideThresholdValue?: CurrencyUSD | null, initialFundingValue?: CurrencyUSD | null, designerAccount?: { __typename?: 'Account', id: string, initialValuation?: { __typename?: 'AssetValuationV2', id: string, effectiveDate: Time, description?: string | null, valuationValue?: CurrencyUSD | null } | null } | null, distributionAssetValuation?: { __typename?: 'AssetValuationV2', id: string, valuationValue?: CurrencyUSD | null } | null, beneficiaries?: Array<{ __typename?: 'Beneficiary', id: string, accessParameters: { __typename?: 'AccessParameterConnection', edges?: Array<{ __typename?: 'AccessParameterEdge', node?: { __typename?: 'AccessParameter', id: string, kind: Types.AccessParameterKind, amount?: CurrencyUSD | null, percentage?: Percent | null } | null } | null> | null }, entity?: { __typename?: 'Entity', id: string, kind: Types.EntityKind, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string }, irrevocableTrust?: { __typename?: 'IrrevocableTrust', id: string, displayName: string, description?: string | null, gstStatus?: Types.EntityGstStatus | null, taxStatus?: Types.TrustTaxStatus | null, beneficiaries?: Array<{ __typename?: 'Beneficiary', id: string, accessParameters: { __typename?: 'AccessParameterConnection', edges?: Array<{ __typename?: 'AccessParameterEdge', node?: { __typename?: 'AccessParameter', id: string, kind: Types.AccessParameterKind, percentage?: Percent | null } | null } | null> | null }, individual?: { __typename?: 'ClientProfile', id: string, displayName: string } | null, organization?: { __typename?: 'ClientOrganization', id: string, name: string } | null, testamentaryEntity?: { __typename?: 'TestamentaryEntity', id: string, kind: Types.TestamentaryEntityKind, displayName: string } | null, entity?: { __typename?: 'Entity', id: string, kind: Types.EntityKind, subtype: { __typename?: 'CCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'CLTTrust', id: string, displayName: string } | { __typename?: 'CRTTrust', id: string, displayName: string } | { __typename?: 'CustodialPersonalAccount', id: string, displayName: string } | { __typename?: 'DonorAdvisedFund', id: string, displayName: string } | { __typename?: 'GPBusinessEntity', id: string, displayName: string } | { __typename?: 'GRATTrust', id: string, displayName: string } | { __typename?: 'ILITTrust', id: string, displayName: string } | { __typename?: 'IndividualPersonalAccount', id: string, displayName: string } | { __typename?: 'InsurancePersonalAccount', id: string, displayName: string } | { __typename?: 'IrrevocableTrust', id: string, displayName: string } | { __typename?: 'JointPersonalAccount', id: string, displayName: string } | { __typename?: 'LLCBusinessEntity', id: string, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, displayName: string } | { __typename?: 'PrivateFoundation', id: string, displayName: string } | { __typename?: 'QPRTTrust', id: string, displayName: string } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, displayName: string } | { __typename?: 'RetirementPersonalAccount', id: string, displayName: string } | { __typename?: 'RevocableTrust', id: string, displayName: string } | { __typename?: 'SCorpBusinessEntity', id: string, displayName: string } | { __typename?: 'SLATTrust', id: string, displayName: string } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, displayName: string } } | null }> | null } | null } | null, individual?: (
      { __typename?: 'ClientProfile' }
      & ClientProfileBasicFragment
    ) | null, testamentaryEntity?: { __typename?: 'TestamentaryEntity', id: string, kind: Types.TestamentaryEntityKind, displayName: string } | null, organization?: { __typename?: 'ClientOrganization', id: string, name: string } | null }> | null, grantor?: { __typename?: 'Principal', id: string, individual?: (
      { __typename?: 'ClientProfile' }
      & ClientProfileBasicFragment
    ) | null } | null };

export type GratAnnuityFragment = { __typename?: 'GRATAnnuityV2', id: string, termDurationYears: number, yearOfTerm: number, failedAnnuityPaymentAmount?: CurrencyUSD | null, paidOn?: Time | null, initialFundingValuePercent: Percent, computedPaymentAmount: CurrencyUSD, actualPaymentAmount: CurrencyUSD, paymentWindowEndDate: Time, paymentWindowStartDate: Time, associatedTask?: (
    { __typename?: 'EntityTask' }
    & EntityTaskFragment
  ) | null, associatedAssetValuation?: (
    { __typename?: 'AssetValuationV2' }
    & AssetValuationV2Fragment
  ) | null };

export type GratPerformanceFragment = { __typename?: 'GRATTrust', id: string, gratSummaryDisplay?: string | null, currentValue: CurrencyUSD, initialFundingValue?: CurrencyUSD | null, mostRecentValuationDate?: Time | null, effectiveDate?: Time | null, officialInterestRatePercent?: Percent | null, taxableGift?: CurrencyUSD | null, grantor?: { __typename?: 'Principal', id: string, individual?: (
      { __typename?: 'ClientProfile' }
      & ClientProfileBasicFragment
    ) | null } | null, distributionAssetValuation?: { __typename?: 'AssetValuationV2', id: string, valuationValue?: CurrencyUSD | null } | null, mostRecentValuation?: (
    { __typename?: 'AssetValuationV2' }
    & AssetValuationV2Fragment
  ) | null, trustees?: Array<{ __typename?: 'Trustee', id: string, individual?: (
      { __typename?: 'ClientProfile' }
      & ClientProfileBasicFragment
    ) | null }> | null, annuities?: Array<(
    { __typename?: 'GRATAnnuityV2' }
    & GratAnnuityFragment
  )> | null };

export const Operations = {
  Fragment: {
    GratTrust: 'GratTrust' as const,
    GRATAnnuity: 'GRATAnnuity' as const,
    GratPerformance: 'GratPerformance' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const GratTrustFragmentDoc = gql`
    fragment GratTrust on GRATTrust {
  id
  distributionDate
  displayName
  annuityAnnualIncreasePercent
  gstStatus
  effectiveDate
  downsideThresholdPercent
  assetSummaryDisplay
  designerAccount {
    id
    initialValuation {
      id
      effectiveDate
      description
      valuationValue
    }
  }
  completionDate
  distributionAssetValuation {
    id
    valuationValue
  }
  beneficiaries {
    id
    accessParameters {
      edges {
        node {
          id
          kind
          amount
          percentage
        }
      }
    }
    entity {
      id
      kind
      subtype {
        id
        displayName
      }
      irrevocableTrust {
        id
        displayName
        description
        gstStatus
        taxStatus
        beneficiaries {
          id
          accessParameters {
            edges {
              node {
                id
                kind
                percentage
              }
            }
          }
          individual {
            id
            displayName
          }
          organization {
            id
            name
          }
          testamentaryEntity {
            id
            kind
            displayName
          }
          entity {
            id
            kind
            subtype {
              id
              displayName
            }
          }
        }
      }
    }
    individual {
      ...ClientProfileBasic
    }
    testamentaryEntity {
      id
      kind
      displayName
    }
    organization {
      id
      name
    }
  }
  grantorRetainedInterest
  grantor {
    id
    individual {
      ...ClientProfileBasic
    }
  }
  currentValue
  description
  gratSummaryDisplay
  implementationNotesToAttorney
  impliedEstateTaxSavings
  inEstateStatus
  legalName
  officialInterestRatePercent
  projectedMarketValue
  projectedRateOfReturn
  projectedSharePrice
  rollingPeriodYears
  targetTaxableGift
  taxStatus
  taxableGift
  termDurationYears
  termEndDate
  trustJurisdictionStateCode
  upsideAsTargetSurplus
  upsideThresholdPercent
  upsideThresholdValue
  initialFundingValue
}
    ${ClientProfileBasicFragmentDoc}`;
export const GratAnnuityFragmentDoc = gql`
    fragment GRATAnnuity on GRATAnnuityV2 {
  id
  termDurationYears
  yearOfTerm
  failedAnnuityPaymentAmount
  paidOn
  initialFundingValuePercent
  computedPaymentAmount
  actualPaymentAmount
  paymentWindowEndDate
  paymentWindowStartDate
  associatedTask {
    ...EntityTask
  }
  associatedAssetValuation {
    ...AssetValuationV2
  }
}
    ${EntityTaskFragmentDoc}
${AssetValuationV2FragmentDoc}`;
export const GratPerformanceFragmentDoc = gql`
    fragment GratPerformance on GRATTrust {
  id
  grantor {
    id
    individual {
      ...ClientProfileBasic
    }
  }
  gratSummaryDisplay
  currentValue
  initialFundingValue
  mostRecentValuationDate
  effectiveDate
  distributionAssetValuation {
    id
    valuationValue
  }
  mostRecentValuation {
    ...AssetValuationV2
  }
  trustees {
    id
    individual {
      ...ClientProfileBasic
    }
  }
  officialInterestRatePercent
  taxableGift
  annuities {
    ...GRATAnnuity
  }
}
    ${ClientProfileBasicFragmentDoc}
${AssetValuationV2FragmentDoc}
${GratAnnuityFragmentDoc}`;